import { Reply } from '..';
import { getCommunityRoute } from '../../api/apiRoutes';
import {
  axiosDeleteRequest,
  axiosGetPaginatedRequest,
  axiosGetRequest,
  axiosPatchRequest,
  axiosPostRequest,
  axiosPutRequest,
} from '../../api/axios';
import { SMALL_PAGE_SIZE } from '../../api/constants';
import { PollDto } from './dtos/PollDto';
import { SubmitPollDto } from './dtos/SubmitPollDto';
import { Poll } from './models/Poll';
import { PollsResponse } from './models/PollsResponse';
import { PollWithQuestionsList } from './models/PollWithQuestionsList';

export const fetchPollsCall = (
  xMsContinuationToken?: string,
  numrecs?: number,
  status?: string,
  roomId?: string
) => {
  return axiosGetPaginatedRequest<PollsResponse>(
    `${getCommunityRoute()}/room/${roomId}/surveys/${
      numrecs || SMALL_PAGE_SIZE
    }?status=${status ? status : 'all'}`,
    xMsContinuationToken
  );
};

export const getNumberOfActiveAndClosedPollsCall = (roomId: string) => {
  return axiosGetRequest<{ open: number; closed: number }>(
    `${getCommunityRoute()}/room/${roomId}/surveyscount`
  );
};

export const fetchPollCall = (pollId: string) => {
  return axiosGetRequest<PollWithQuestionsList>(
    `${getCommunityRoute()}/survey/${pollId}`
  );
};

export const submitPollCall = (pollToSubmit: SubmitPollDto) => {
  return axiosPostRequest<SubmitPollDto, PollWithQuestionsList>(
    `${getCommunityRoute()}/survey/${pollToSubmit.id}`,
    pollToSubmit
  );
};

export const createNewPollCall = (poll: PollDto, roomId: string) => {
  return axiosPostRequest<PollDto, Poll>(
    `${getCommunityRoute()}/room/${roomId}/survey`,
    poll
  );
};

export const reportPollCall = (pollId: string) => {
  return axiosPatchRequest<void, string>(
    `${getCommunityRoute()}/survey/${pollId}/report`
  );
};

export const updatePollCall = (poll: PollDto) => {
  return axiosPutRequest<PollDto, Poll>(
    `${getCommunityRoute()}/survey/${poll.id}`,
    poll
  );
};

export const deletePollCall = (pollId: string) => {
  return axiosDeleteRequest<string, Reply>(
    `${getCommunityRoute()}/survey/${pollId}`
  );
};

export const moderatorDeletePollCall = (pollId: string, roomId: string) => {
  return axiosDeleteRequest<string, Reply>(
    `${getCommunityRoute()}/moderator/room/${roomId}/survey/${pollId}`
  );
};
